import {
  destinationUrlColumn, finalUrlSuffixColumn, absoluteTopImpressionRateColumn, advertiserReportedRevenue, allConversionAdvertiserReportedRevenue, allConversionCPAColumn,
  allConversionRateColumn, allConversionRevenueOnAdSpendColumn, allConversionsColumn, averageCPCColumn, averageCPMColumn, clicksColumn, conversionRateColumn,
  conversionsColumn, CPAColumn, CTRColumn, impressionsColumn, returnOnAdSpendColumn, spendColumn, trackingUrlTemplateColumn, urlCustomParametersColumn,
  netRevenueColumn, eligibleImpressionsColumn, missedImpressionsColumn, impressionShareColumn, missedImpressionsNoBidColumn,
  missedImpressionsSpendingCapReachedColumn, missedImpressionsInsufficientBidColumn, missedImpressionsNoTaxColumn,
  missedImpressionsOtherColumn, ColumnKeyOdataPathMap, averageCPSColumn, salesCountColumn,
} from '@bingads-webui-grid/well-known';

import {
  ListingGroupColumn,
  AssetGroupNameColumn,
  IncludeExcludeColumn
} from './rawColumns';

/**
 * To know how to get column raw data by column key
 */
export const columnKeyRawDataMap = {
  [ListingGroupColumn.key]: ListingGroupColumn,
  [AssetGroupNameColumn.key]: AssetGroupNameColumn,
  [IncludeExcludeColumn.key]: IncludeExcludeColumn,
  [absoluteTopImpressionRateColumn.key]: absoluteTopImpressionRateColumn,
  [advertiserReportedRevenue.key]: advertiserReportedRevenue,
  [allConversionAdvertiserReportedRevenue.key]: allConversionAdvertiserReportedRevenue,
  [allConversionCPAColumn.key]: allConversionCPAColumn,
  [allConversionRateColumn.key]: allConversionRateColumn,
  [allConversionRevenueOnAdSpendColumn.key]: allConversionRevenueOnAdSpendColumn,
  [allConversionsColumn.key]: allConversionsColumn,
  [averageCPCColumn.key]: averageCPCColumn,
  [averageCPMColumn.key]: averageCPMColumn,
  [CPAColumn.key]: CPAColumn,
  [CTRColumn.key]: CTRColumn,
  [clicksColumn.key]: clicksColumn,
  [conversionRateColumn.key]: conversionRateColumn,
  [conversionsColumn.key]: conversionsColumn,
  [impressionsColumn.key]: impressionsColumn,
  [returnOnAdSpendColumn.key]: returnOnAdSpendColumn,
  [spendColumn.key]: spendColumn,
  [eligibleImpressionsColumn.key]: eligibleImpressionsColumn,
  [missedImpressionsColumn.key]: missedImpressionsColumn,
  [missedImpressionsNoBidColumn.key]: missedImpressionsNoBidColumn,
  [missedImpressionsSpendingCapReachedColumn.key]: missedImpressionsSpendingCapReachedColumn,
  [missedImpressionsInsufficientBidColumn.key]: missedImpressionsInsufficientBidColumn,
  [missedImpressionsNoTaxColumn.key]: missedImpressionsNoTaxColumn,
  [missedImpressionsOtherColumn.key]: missedImpressionsOtherColumn,
  [impressionShareColumn.key]: impressionShareColumn,
  [averageCPSColumn.key]: averageCPSColumn,
  [salesCountColumn.key]: salesCountColumn,

  // FIXME: this is not added by back-end, so the data is always undefined/0(depend on how to treat undefeined data)
  // This should be an undefined behavior to visit them, but we could use them here to avoid page crash
  [netRevenueColumn.key]: netRevenueColumn,


  // FIXME: According to back-end's opinion, this column is not in back-end DB, so we should not have this column.
  [destinationUrlColumn.key]: destinationUrlColumn,

} as const;

export const cpsColumnKeys = [
  averageCPSColumn.key,
  salesCountColumn.key,
];

const odataPathOfCommonColumnsIterable: [string, string][] = [
  [absoluteTopImpressionRateColumn.key, 'PerformanceMetrics/AbsoluteTopImpressionRate'],
  [advertiserReportedRevenue.key, 'PerformanceMetrics/AdvertiserReportedRevenue'],
  [allConversionAdvertiserReportedRevenue.key, 'PerformanceMetrics/AllConversionAdvertiserReportedRevenue'],
  [allConversionCPAColumn.key, 'PerformanceMetrics/AllConversionCPA'],
  [allConversionRateColumn.key, 'PerformanceMetrics/AllConversionRate'],
  [allConversionRevenueOnAdSpendColumn.key, 'PerformanceMetrics/AllConversionRevenueOnAdSpend'],
  [allConversionsColumn.key, 'PerformanceMetrics/AllConversions'],
  [averageCPCColumn.key, 'PerformanceMetrics/AverageCPC'],
  [averageCPMColumn.key, 'PerformanceMetrics/AverageCPM'],
  [CPAColumn.key, 'PerformanceMetrics/CPA'],
  [CTRColumn.key, 'PerformanceMetrics/CTR'],
  [clicksColumn.key, 'PerformanceMetrics/Clicks'],
  [conversionRateColumn.key, 'PerformanceMetrics/ConversionRate'],
  [conversionsColumn.key, 'PerformanceMetrics/Conversions'],
  [impressionsColumn.key, 'PerformanceMetrics/Impressions'],
  [impressionShareColumn.key, 'PerformanceMetrics/ImpressionShare'],
  [returnOnAdSpendColumn.key, 'PerformanceMetrics/RevenueOnAdSpend'],
  [spendColumn.key, 'PerformanceMetrics/Spend'],
  [eligibleImpressionsColumn.key, 'PerformanceMetrics/EligibleImpressions'],
  [missedImpressionsColumn.key, 'PerformanceMetrics/MissedImpressions'],
  [missedImpressionsNoBidColumn.key, 'PerformanceMetrics/MissedImpressionsNoBid'],
  [missedImpressionsSpendingCapReachedColumn.key, 'PerformanceMetrics/MissedImpressionsSpendingCapReached'],
  [missedImpressionsInsufficientBidColumn.key, 'PerformanceMetrics/MissedImpressionsInsufficientBid'],
  [missedImpressionsNoTaxColumn.key, 'PerformanceMetrics/MissedImpressionsNoTax'],
  [missedImpressionsOtherColumn.key, 'PerformanceMetrics/MissedImpressionsOther'],
  [urlCustomParametersColumn.key, 'UrlCustomParameters'],
  [finalUrlSuffixColumn.key, 'FinalUrlSuffix'],
  [trackingUrlTemplateColumn.key, 'TrackingUrlTemplate'],
  [destinationUrlColumn.key, 'DestinationUrl'],
  [averageCPSColumn.key, 'PerformanceMetrics/AverageCPS'],
  [salesCountColumn.key, 'PerformanceMetrics/SalesCount'],
];

const odataPathOfListingGroupColumnIterable: [string, string][] = [
  [ListingGroupColumn.key, 'Condition/Attribute'],
  [AssetGroupNameColumn.key, 'AssetGroupName'],
  [IncludeExcludeColumn.key, 'IsExcluded'],
];

export const odataMapOfListingGroupResponse: ColumnKeyOdataPathMap = new Map([...odataPathOfCommonColumnsIterable, ...odataPathOfListingGroupColumnIterable]);
